/* unplugin-vue-components disabled */import { render } from "./user-table.vue?vue&type=template&id=b9c7ceb8&scoped=true"
import script from "./user-table.vue?vue&type=script&lang=js"
export * from "./user-table.vue?vue&type=script&lang=js"

import "./user-table.vue?vue&type=style&index=0&id=b9c7ceb8&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c7ceb8"],['__file',"src/pages/settings/admin/user-table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9c7ceb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9c7ceb8', __exports__)) {
    api.reload('b9c7ceb8', __exports__)
  }
  
  module.hot.accept("./user-table.vue?vue&type=template&id=b9c7ceb8&scoped=true", () => {
    api.rerender('b9c7ceb8', render)
  })

}


export default __exports__